<template>
  <label class="pathways-option">
    <slot />
    <span class="pathways-option__display">{{ labelText }}</span>
  </label>
</template>

<script>
export default {
  name: 'PathwaysOption',
  props: {
    labelText: String,
  },
};
</script>
